import { jsx as _jsx } from "react/jsx-runtime";
import Chart from "react-apexcharts";
import CardChart from "./Charts";
import { useTranslation } from "react-i18next";
export var VotersByChannel = function (_a) {
    var data = _a.data, width = _a.width, height = _a.height;
    var t = useTranslation().t;
    var visibleData = data.filter(function (_a) {
        var count = _a.count;
        return count > 0;
    });
    var state = {
        options: {
            labels: visibleData.map(function (item) {
                return String(t("common.channel.".concat(item.channel.toLowerCase())));
            }),
            plotOptions: {
                pie: {
                    donut: {
                        labels: {
                            show: true,
                            total: {
                                showAlways: true,
                                show: true,
                            },
                        },
                    },
                },
            },
        },
        series: visibleData.map(function (item) { return item.count; }),
    };
    return (_jsx(CardChart, { title: String(t("dashboard.votersByChannels")), children: _jsx(Chart, { options: state.options, series: state.series, type: "donut", width: width, height: height }) }));
};
